import { Job, SupabaseJob } from '@applicator/shared'

// Подсчет релевантности для статистики
// Используем relevance_verdict для синхронизации с SearchQueries
export function calculateRelevanceCounts(
  jobs: Job[],
  supabaseJobs: SupabaseJob[]
): { relevant: number; nonRelevant: number; notAnalyzed: number; total: number } {
  let relevant = 0
  let nonRelevant = 0
  let notAnalyzed = 0

  jobs.forEach((job) => {
    const jobId = job.id || ''
    const supabaseJob = supabaseJobs.find(j => j.id === jobId)
    if (supabaseJob?.relevance_verdict === 'Fit') {
      relevant++
    } else if (supabaseJob?.relevance_verdict === 'No Fit') {
      nonRelevant++
    } else {
      notAnalyzed++
    }
  })

  return { relevant, nonRelevant, notAnalyzed, total: jobs.length }
}
